import { render, staticRenderFns } from "./Packinglist.vue?vue&type=template&id=02b1779e&scoped=true&"
import script from "./Packinglist.vue?vue&type=script&lang=js&"
export * from "./Packinglist.vue?vue&type=script&lang=js&"
import style0 from "./Packinglist.vue?vue&type=style&index=0&id=02b1779e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b1779e",
  null
  
)

export default component.exports